import { render, staticRenderFns } from "./POPsDetails.vue?vue&type=template&id=8eb46e46&"
import script from "./POPsDetails.vue?vue&type=script&lang=js&"
export * from "./POPsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports